import {
  AuditOutlined,
  FileDoneOutlined,
  FolderOpenOutlined,
  FolderOutlined,
  ReconciliationOutlined,
} from "@ant-design/icons";
import { CircularProgressbar } from "react-circular-progressbar";
import React, { useEffect, useState } from "react";
import { getDashboardLeaDetails, getListeClients } from "../../data/client";
import { Link, useNavigate } from "react-router-dom";
import { getClientAbonnement } from "../../data/bogClient";
import moment from "moment";
import { useSelector } from "react-redux";
import {
  Button,
  Col,
  Input,
  message,
  Modal,
  Row,
  Space,
  Table,
  Tag,
  Tooltip,
  Form,
} from "antd";
import TableTitle from "../../components/common/TableTitle";
import { faEye, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getExerciceDetails } from "../../data/exercice";

const DashBoardPage = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);

  // States
  const [abonnement, setAbonnement] = useState(null);
  const [exercices, setExercices] = useState([]);
  const [percentage, setPercentage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dashboard, setDashboard] = useState(null);
  const [modalAdd, setModalAdd] = useState(false);

  const isAdmin = user?.libelleProfil === "Admin";

  /** Charger les données du dashboard */
  useEffect(() => {
    setLoading(true);
    getDashboardLeaDetails()
      .then(async (res) => {
        if (res) {
          setDashboard(res);
          setExercices(res?.exercicessUser || []);
        }
      })
      .catch((err) => console.error("Erreur récupération dashboard :", err))
      .finally(() => setLoading(false));
  }, []);

  /** Charger l'abonnement du client si disponible */
  useEffect(() => {
    if (!user?.client_id) return;

    setLoading(true);
    getClientAbonnement(user.client_id)
      .then((res) => {
        if (res?.result) {
          setAbonnement(res.result);
          // Calcul du pourcentage de progression
          const debut = moment(res.result.date_debut_abon);
          const fin = moment(res.result.date_fin_abon);
          const pourcentage = Math.max(
            0,
            Math.min(100, ((moment() - debut) / (fin - debut)) * 100),
          );
          setPercentage(parseInt(pourcentage));
        }
      })
      .catch((err) => console.error("Erreur récupération abonnement :", err))
      .finally(() => setLoading(false));
  }, [user?.client_id]);

  /** Toggle modal réabonnement */
  const handleModalAdd = () => {
    setLoading(true);
    setTimeout(() => {
      setModalAdd((prev) => !prev);
      setLoading(false);
    }, 1000);
  };

  /** Colonnes du tableau Exercices */
  const dataColumns = [
    {
      title: <TableTitle>#</TableTitle>,
      width: 50,
      render: (_, __, index) => <>{index + 1}</>,
    },
    {
      title: <TableTitle>Exercice</TableTitle>,
      dataIndex: "exercice",
      key: "exercice",
      render: (_, record) => {
        return (
          <>
            <div className="d-flex align-items-center">
              <div className="symbol symbol-45px me-5">
                <FolderOpenOutlined
                  style={{ fontSize: "3rem", color: "rgb(250, 152, 28)" }}
                />
              </div>
              <div className="d-flex justify-content-start flex-column">
                <Link
                  className="text-gray-800 text-hover-primary"
                  to={`/clients/mission/exploitation/${record?.exercice_id}`}
                  state={{ record: record?.client, mission: record?.mission }}
                >
                  <span className="text-dark fw-bolder text-hover-primary fs-6">
                    {record?.mission_name || ""} - {record?.mission_annee || ""}
                  </span>
                  <span className="text-muted fw-bold text-muted d-block fs-9 text-uppercase py-1">
                    <Tag>{record?.sigle_client}</Tag> | {record?.status_client}
                  </span>
                  <span className="text-black fw-bold d-block fs-7 text-uppercase">
                    {record?.secteur_client}
                  </span>
                </Link>
              </div>
            </div>
          </>
        );
      },
    },
    {
      title: <TableTitle>Manager</TableTitle>,
      key: "manager",
      render: (_, record) => (
        <>
          <Space>
            <div className="fs-2 text-warning pe-2">
              <FontAwesomeIcon icon={faUser} />
            </div>
            <span className="text-dark fw-bolder d-block text-hover-primary fs-5 text-uppercase">
              {record?.nom_manager
                ? `${record.nom_manager} ${record?.prenom_manager || ""}`
                : ""}
            </span>
          </Space>
        </>
      ),
    },
    {
      title: <TableTitle>Statut</TableTitle>,
      key: "status",
      render: (_, record) => (
        <>
          {!record?.isCloture ? (
            record?.isLettreMission === 0 && record?.mission?.etat === 1 ? (
              <Tag color="yellow">En attente</Tag>
            ) : (
              <Tag color="blue">En cours</Tag>
            )
          ) : (
            <Tag color="green">Clôturé</Tag>
          )}
        </>
      ),
    },
    /* {
      title: <TableTitle>Progression</TableTitle>,
      key: "progression",
      render: (_, record) => (
        <div className="d-flex flex-column w-100 me-2">
          <div className="d-flex flex-stack mb-2">
            <span className="text-muted me-2 fs-7 fw-bold">
              {record?.isCloture ? 100 : record?.progression}
            </span>
          </div>
          <div className="progress h-6px w-100">
            <div
              className={`progress-bar bg-${record?.color}`}
              style={{
                width: `${record?.isCloture ? 100 : record?.progression}%`,
              }}
            />
          </div>
        </div>
      ),
    }, */
    {
      title: <TableTitle>Actions</TableTitle>,
      key: "actions",
      align: "right",
      width: 100,
      render: (_, record) => (
        <Tooltip title="Consulter le sommaire">
          <Button
            type="primary"
            icon={<FontAwesomeIcon icon={faEye} />}
            onClick={() =>
              navigate(`/clients/mission/exploitation/${record?.exercice_id}`, {
                state: { record: record?.client, mission: record?.mission },
              })
            }
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <div id="kt_content_container" className="container-xxl">
        <div className="row g-5 g-xl-12">
          <div className="col-xl-4">
            <Link
              to="/exercices/termines"
              state={{ dossiers: dashboard?.exercicessUser }}
              className="card bg-warning hoverable card-xl-stretch mb-xl-8"
            >
              <div className="card-body d-flex align-items-center">
                <div className="row w-100">
                  <div className="col-3 d-flex justify-content-center align-items-center">
                    <FileDoneOutlined
                      style={{ fontSize: "7rem", color: "#fff" }}
                    />
                  </div>

                  <div className="col-9 d-flex flex-column justify-content-center">
                    <div className="text-white fw-bolder fs-1 mb-2">
                      <span style={{ fontSize: "2.1rem" }}>
                        Exercices Terminés
                      </span>
                    </div>
                    <div
                      className="fw-bold text-white"
                      style={{ fontSize: "1.1rem" }}
                    >
                      {(isAdmin
                        ? dashboard?.nbrExercicesClotures
                        : dashboard?.nbrExercicesCloturesUser) || 0}{" "}
                      Exercices terminés
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          {/* Exercices en cours */}
          <div className="col-xl-4">
            <Link
              to="/exercices/en-cours"
              state={{ dossiers: dashboard?.exercicessUser }}
              className="card bg-danger hoverable card-xl-stretch mb-xl-8"
            >
              <div className="card-body d-flex align-items-center">
                <div className="row w-100">
                  <div className="col-3 d-flex justify-content-center align-items-center">
                    <ReconciliationOutlined
                      style={{ fontSize: "7rem", color: "#fff" }}
                    />
                  </div>

                  <div className="col-9 d-flex flex-column justify-content-center">
                    <div className="text-white fw-bolder fs-1 mb-2">
                      <span style={{ fontSize: "2.1rem" }}>
                        Exercices en cours
                      </span>
                    </div>
                    <div
                      className="fw-bold text-white"
                      style={{ fontSize: "1.1rem" }}
                    >
                      {(isAdmin
                        ? dashboard?.nbrExercicesCours
                        : dashboard?.exercicesCoursUser?.length) || 0}{" "}
                      Exercices en cours
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          {/* Mes exercices */}
          {/* <div className="col-xl-4">
            <Link
              to="/clients/liste"
              className="card bg-primary hoverable card-xl-stretch mb-xl-8"
            >
              <div className="card-body">
                <AuditOutlined style={{ fontSize: "4rem", color: "#fff" }} />
                <div className="text-white fw-bolder fs-2 mb-2 mt-5">
                  Mes Exercices
                </div>
                <div className="fw-bold text-white">
                  {(isAdmin
                    ? dashboard?.nbrExercices
                    : dashboard?.exercicessUser?.length) || 0}{" "}
                  Exercices
                </div>
              </div>
            </Link>
          </div> */}

          {/* Mes dossiers */}
          <div className="col-xl-4">
            <Link
              to="/dossiers/liste"
              state={{ dossiers: dashboard?.exercicessUser }}
              className="card bg-success hoverable card-xl-stretch mb-5 mb-xl-8"
            >
              <div className="card-body d-flex align-items-center">
                <div className="row w-100">
                  <div className="col-3 d-flex justify-content-center align-items-center">
                    <FolderOutlined
                      style={{ fontSize: "7rem", color: "#fff" }}
                    />
                  </div>

                  <div className="col-9 d-flex flex-column justify-content-center">
                    <div className="text-white fw-bolder fs-1 mb-2">
                      <span style={{ fontSize: "2.1rem" }}>Mes Dossiers</span>
                    </div>
                    <div
                      className="fw-bold text-white"
                      style={{ fontSize: "1.1rem" }}
                    >
                      {(isAdmin
                        ? dashboard?.nbrClientsLeas
                        : dashboard?.dossiersUserConnecte) || 0}{" "}
                      Dossiers
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>

        {/* Abonnement + Dossiers en cours */}
        <div className="gy-5 g-xl-8 mt-5">
          <Row gutter={[16, 16]}>
            {/* Progression abonnement (admin uniquement) */}
            <Col xs={24} lg={8}>
              {isAdmin && (
                <div className="card card-xl-stretch">
                  <div className="card-header border-0 py-5">
                    <h3 className="card-title flex-column">
                      <span className="card-label fw-bolder fs-3 mb-1">
                        Abonnement
                      </span>
                      <span className="text-muted fw-bold fs-7">
                        Progression de votre abonnement
                      </span>
                    </h3>
                    <div className="card-toolbar" style={{ margin: "auto" }}>
                      <CircularProgressbar
                        value={percentage}
                        text={`${percentage}%`}
                      />
                    </div>
                  </div>

                  {/* Alerte si proche de la fin */}
                  {percentage > 80 && (
                    <div className="card-body d-flex flex-column">
                      <div className="pt-5">
                        <p className="text-center fs-6 pb-5">
                          <span className="badge badge-light-danger fs-8">
                            Notes:
                          </span>
                          Votre abonnement sera bientôt épuisé.
                          <br />
                          Cliquez ici pour faire une demande de réabonnement.
                        </p>
                        <div
                          className="btn btn-primary w-100 py-3 cursor-pointer"
                          onClick={handleModalAdd}
                        >
                          Demande de réabonnement
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </Col>

            {/* Tableau dossiers en cours */}
            {exercices.length > 0 && (
              <Col xs={24} lg={16}>
                <div className="card card-xxl-stretch mb-5 mb-xl-8">
                  <div className="card-header border-0 pt-5">
                    <h2 className="card-title flex-column">
                      <span className="card-label fw-bolder fs-2 mb-1">
                        Dossiers en cours
                      </span>
                      <span className="text-muted mt-1 fw-bold fs-6">
                        Etat des dossiers en cours
                      </span>
                    </h2>
                  </div>
                  <div className="card-body py-3">
                    <Table
                      columns={dataColumns}
                      dataSource={exercices.filter((item) => !item?.isCloture)}
                      pagination={{ pageSize: 5, showSizeChanger: false }}
                      size="small"
                    />
                  </div>
                </div>
              </Col>
            )}
          </Row>
        </div>
      </div>

      {/* Modal réabonnement (commenté pour l’instant) */}
      {/* <ModalAddAbonnement open={modalAdd} setOpen={setModalAdd} /> */}
    </div>
  );
};

/** Modal Ajout/Edition de catégorie de prestation */
const ModalAddAbonnement = ({ open, setOpen, data, isEdit, getData }) => {
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      libelle_prestation: data?.libelle_prestation || "",
      code_prestation: data?.code_prestation || "",
      description_prestation: data?.description_prestation || "",
      type_prestation: data?.type_prestation || "",
    },
    validationSchema: Yup.object({
      libelle_prestation: Yup.string().required("Le libellé est obligatoire"),
      code_prestation: Yup.string().required("Le code est obligatoire"),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        // TODO: Appeler API pour ajout ou modification
        // const endpoint = isEdit ? ENDPOINTS.MODIFIER : ENDPOINTS.AJOUTER;
        // const payload = isEdit ? { ...values, id: data.id } : values;
        // const res = await RqAxios.post(endpoint, payload);
        // Gérer success/error avec message.success / message.error
      } catch {
        message.error("Une erreur s'est produite");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCancel = () => setOpen(false);

  return (
    <Modal
      title={`${isEdit ? "Modifier" : "Ajouter"} une catégorie de prestation`}
      open={open}
      onOk={formik.handleSubmit}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText={isEdit ? "Modifier" : "Ajouter"}
      cancelText="Annuler"
      width={600}
    >
      <Form layout="vertical">
        {/* Code prestation */}
        <Form.Item
          label={
            <>
              Code <span style={{ color: "red" }}>*</span>
            </>
          }
          validateStatus={
            formik.touched.code_prestation && formik.errors.code_prestation
              ? "error"
              : ""
          }
          help={formik.touched.code_prestation && formik.errors.code_prestation}
        >
          <Input
            placeholder="Code"
            name="code_prestation"
            value={formik.values.code_prestation}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Form.Item>

        {/* Libellé prestation */}
        <Form.Item
          label={
            <>
              Libellé <span style={{ color: "red" }}>*</span>
            </>
          }
          validateStatus={
            formik.touched.libelle_prestation &&
            formik.errors.libelle_prestation
              ? "error"
              : ""
          }
          help={
            formik.touched.libelle_prestation &&
            formik.errors.libelle_prestation
          }
        >
          <Input
            placeholder="Libellé"
            name="libelle_prestation"
            value={formik.values.libelle_prestation}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Form.Item>

        {/* Description */}
        <Form.Item label="Description">
          <Input.TextArea
            placeholder="Description"
            name="description_prestation"
            value={formik.values.description_prestation}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Form.Item>

        {/* Type prestation */}
        <Form.Item label="Type de prestation">
          <Input
            placeholder="Type de prestation"
            name="type_prestation"
            value={formik.values.type_prestation}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DashBoardPage;
